import { COLOR_PALETTE } from 'constants/ui';

import { HTML_TEMPLATE_FIELD_SELECTOR } from '../../FormChangeHistory.constants';

// The frame's page stays white in dark mode, so the mark uses fixed light-page colours, not theme ones.
export const TEMPLATE_FIELD_MARK_CSS = `${HTML_TEMPLATE_FIELD_SELECTOR} {
  padding: 0 4px;
  border-radius: 4px;
  background-color: ${COLOR_PALETTE.BLUE[2]};
  color: ${COLOR_PALETTE.BLUE[8]};
}`;

// The template is a printable document authored on white paper, like a PDF page: it keeps that
// surface in dark mode instead of showing its dark text on the modal's dark background.
export const htmlFrameStyles = {
  width: '100%',
  height: '80vh',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.common.white,
};

export const htmlViewStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
};
